
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-prefit-prelims-test-series",
      function () {
        return require("private-next-pages/upsc-prefit-prelims-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-prefit-prelims-test-series"])
      });
    }
  